import axios from "axios";

import { getStore } from "../../redux/configureStore";
import { loginExpired } from "../../features/auth/authSlice";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => (console.log(response),response),
  (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.data?.error === "token expired"
    ) {
      getStore().dispatch(loginExpired());
    }
    return Promise.reject(error);
  },
);

export default api;
